module.exports = __webpack_public_path__ + "img/num02_white.16df7b63.svg";